import { render, staticRenderFns } from "./FactorCard.vue?vue&type=template&id=2b09b05f&"
import script from "./FactorCard.vue?vue&type=script&lang=js&"
export * from "./FactorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports